import axios from 'axios';

// Define a URL base da sua API Laravel.
const API_URL = 'https://alleanzabrasilcorretora.com.br/backend/public/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

/**
 * Busca a lista de HOSPITAIS próximos.
 * CORREÇÃO: Usa o método POST para corresponder à rota do back-end.
 */
export const fetchHospitalsNearby = async (cep) => {
  try {
    const response = await apiClient.post('/hospitals/nearby', { cep });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar hospitais próximos:', error);
    throw error;
  }
};

/**
 * Busca a lista de PLANOS disponíveis para um CEP.
 * CORREÇÃO: Usa o método POST para corresponder à rota do back-end.
 */
export const fetchPlansNearby = async (cep) => {
  try {
    const response = await apiClient.post('/plans/nearby', { cep });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar planos próximos:', error);
    throw error;
  }
};


/**
 * Cria um novo lead no sistema.
 */
export const createLead = async (leadData) => {
  try {
    const response = await apiClient.post('/leads', leadData);
    return response;
  } catch (error) {
    console.error('Erro na API ao criar lead:', error);
    throw error;
  }
};

/**
 * Cria uma nova solicitação de plano.
 */
export const createSolicitation = async (solicitationData) => {
  try {
    const response = await apiClient.post('/solicitation', solicitationData);
    return response;
  } catch (error) {
    console.error('Erro na API ao criar solicitação:', error);
    throw error;
  }
};
